import { createFileRoute, redirect } from "@tanstack/react-router";
import { Transaction_Type } from "schema/gen/es/chiikipoint/model/v2/model_pb";
import { TransactionDetail } from "../../../features/transactions";
import { AppError, ERROR_CODES } from "../../../libs/errors";

export const Route = createFileRoute("/_authed/transactions/$groupId")({
  loader: async ({ context: { client }, params: { groupId } }) => {
    const response = await client
      .getMyTransaction({
        transactionGroupId: groupId,
      })
      .catch((error) => {
        throw new AppError(
          ERROR_CODES.CONNECT_GET_MY_TRANSACTION_FAILED,
          error.message,
          {
            originalError: error,
          },
        );
      });
    if (!response.transactionGroup) {
      throw redirect({ to: "/transactions" });
    }

    const transactionGroup = response.transactionGroup;
    const balances = response.balances;

    let type = transactionGroup.transactionDetails[0].transaction?.type;

    const refund = transactionGroup.transactionDetails.find(
      (d) => d.transaction?.type === Transaction_Type.REFUND,
    );
    if (refund) {
      type = Transaction_Type.REFUND;
    }

    if (!type) {
      throw new AppError(ERROR_CODES.TRANSACTION_TYPE_UNSPECIFIED);
    }

    return { transactionGroup, type, balances };
  },
  component: Transaction,
});

function Transaction() {
  const { transactionGroup, type, balances } = Route.useLoaderData();
  return (
    <TransactionDetail
      transactionGroup={transactionGroup}
      type={type}
      balances={balances}
    />
  );
}
